import {action, observable, toJS} from "mobx";
import wizardStore from "../store";
import realtimeStore from "../../../stores/RealtimeStore";
import {LessonNotificationType, NotificationType} from "../../../constants/enums";

class WhiteBoardStore {
    @observable whiteBoardTeacherRef = {};
    @observable whiteBoardStudentRef = {};
    @observable mountedTeacherKey = {};
    @observable mountedStudentKey = {};
    @observable patches = {};
    @observable isMarkupDragging = false;

    @action changeMarkupDragging = (val) => {
        this.isMarkupDragging = val;
    }

    getKey = (id, page, isTeacher) => {
        return `${id}_${page}_${isTeacher}`;
    }

    @action setRef = (id, page, isTeacher, isNotation, whiteBoardRef) => {
        // console.log('wb set',id, page, isTeacher, isNotation, whiteBoardRef);
        if (isTeacher) {
            this.mountedTeacherKey[isNotation] = this.getKey(id, page, isTeacher);
            this.whiteBoardTeacherRef[isNotation] = whiteBoardRef;
        } else {
            this.mountedStudentKey[isNotation] = this.getKey(id, page, isTeacher)
            this.whiteBoardStudentRef[isNotation] = whiteBoardRef;
        }
    }

    getPatches = (id, page, isTeacher, isNotation) => {
        return this.patches[this.getKey(id, page, isTeacher, isNotation)] || [];
    }

    deletePatches = (id, page, isTeacher, isNotation) => {
        this.patches[this.getKey(id, page, isTeacher, isNotation)] = null;
    }

    getWhiteBoardRef = (id, page, isTeacher, isNotation) => {
        // console.log('wb get',id, page, isTeacher, isNotation)
        if (isTeacher && this.mountedTeacherKey[isNotation] === this.getKey(id, page, isTeacher)) {
            return this.whiteBoardTeacherRef[isNotation];
        } else if (!isTeacher && this.mountedStudentKey[isNotation] === this.getKey(id, page, isTeacher)) {
            return this.whiteBoardStudentRef[isNotation];
        }
        return null;
    }

    sendCanvasUpdate = async (projectId, canvasPatch) => {
        if (wizardStore.presentMode || wizardStore.presented) {
            await realtimeStore.send(`project:${projectId}`, {
                type: LessonNotificationType.CanvasUpdate,
                objectId: canvasPatch.id,
                objectType: NotificationType.Canvas,
                canvasPatch: toJS(canvasPatch)
            });
        }
    }


    @action updateCanvas = (canvasPatch) => {
        // todo handle patch num issues
        let whiteboardRef = this.getWhiteBoardRef(canvasPatch.id, canvasPatch.page, canvasPatch.isTeacher, canvasPatch.isNotation);
        if (whiteboardRef) {
            whiteboardRef.updatePatch(canvasPatch.patch);
        } else {
            const key = this.getKey(canvasPatch.id, canvasPatch.page, canvasPatch.isTeacher);
            // console.log('storing patches for: ', key);
            if (this.patches[key]) {
                this.patches[key].push(canvasPatch);
            } else {
                this.patches[key] = [canvasPatch];
            }
        }
    }


}

const whiteBoardStore = new WhiteBoardStore();
export default whiteBoardStore;

